import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash-es';
import Select from 'react-select';
import dotProp from 'dot-prop-immutable';
import { Button, TitleBar, Card, ButtonGroup, SelectFieldWithLabelDatatest, SliderCheckbox, TextFieldWithLabel, TextAreaWithLabel, NumberFieldWithLabel, Layout, Link, Alert, StatusMessage } from '../components/library-components';
import Assets from '../components/assets/assets';
import { getSubscriptionPlan, createOrUpdateSubscriptionPlan, destroySubscriptionPlan, postCreateRemotePlan, getAssetCategoriesCors, getSubscriptionGroup, getSubscriptionGroups, postCreateVoucherifyProduct, updateVoucherifyProduct, connectRecurringPlan, updateRecurringPlan } from '../api';
import { SET_SUBSCRIPTION_PLAN, SET_ERRORS, UPDATE_SUBSCRIPTION_GROUPS } from '../actions';
import occurrence from '../helpers/occurrence';
import currencyUtils, { ALL_CURRENCIES, getOption } from '../helpers/currencyUtils';

import validate from 'validate.js';
import '../../stylesheets/pages/create_update_subscription_plan.scss';

const LIFETIMEVALUE = 'lifetime';
const LIFETIMELABEL = 'lifetime (100 Years)';
const DURATION_UNITS_ONE_TIME = ['days', 'weeks', 'months', 'years', LIFETIMELABEL].map((k) => ({ label: k, value: k === LIFETIMELABEL ? LIFETIMEVALUE : k }));
const DURATION_UNITS_RECURRING = ['days', 'weeks', 'months', 'years'].map((key) => ({ label: key, value: key }));

const TRIAL_PERIOD_DURATION_UNITS = ['days', 'weeks', 'months', 'years'].map((k) => ({ label: k, value: k }));

export class CreateUpdateSubscriptionPlan extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      openAlertPopup: false,
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' },
      assetCategories: null,
      priceCents: '0',
      voucherifyEnabled: _.get(window.qtConfig, 'voucherifyEnabled', false) === 'true',
      enabledPaymentProviders: [],
      superUser: _.get(window.subConfig, 'currentAccountUserRole', '') === 'superuser'
    };
  }

  deleteSubscriptionPlan (e) {
    e.preventDefault();
    destroySubscriptionPlan(this.props.subscriptionGroupId, this.props.subscriptionPlanId)
      .then((response) => { window.location = `/subscription_groups/${this.props.subscriptionGroupId}`; },
        (error) => { console.log(error, 'error'); });
    this.setState({ openAlertPopup: false });
  }

  openAlert () {
    this.setState({ openAlertPopup: true });
  }

  closeAlert () {
    this.setState({ openAlertPopup: false });
  }

  componentDidMount () {
    getSubscriptionPlan(this.props.subscriptionGroupId, this.props.subscriptionPlanId)
      .then(plan => {
        this.setState({ priceCents: currencyUtils.convertToCurrencyUnits(plan.price_cents) });
        this.props.setSubscriptionPlan(plan);
      },
      errors => { window.location = '/404.html'; }
      );
    getAssetCategoriesCors().then(assetCategories => this.setState({ assetCategories: assetCategories }));
    getSubscriptionGroup(this.props.subscriptionGroupId)
      .then(group => {
        this.setState({
          subscriptionGroupName: group.name,
          subscriptionGroupType: group.subscription_type,
          subscriptionGroupCurrency: group.currency
        });
      });
    getSubscriptionGroups().then(plans => this.props.setSubscriptionGroups(plans));
  }

  createUpdateSubscriptionPlan () {
    var errors = validate(this.props.subscriptionPlan, this.constraintsSubscriptionPlan());
    if (!errors) {
      createOrUpdateSubscriptionPlan(this.props.subscriptionGroupId, this.props.subscriptionPlan).then((response) => {
        window.location = `/subscription_groups/${this.props.subscriptionGroupId}`;
      }, errors => this.props.setErrors(errors.errors));
    } else {
      this.props.setErrors(errors);
    }
  }

  constraintsSubscriptionPlan () {
    const groupAccessUserLimitConstraint = {
      user_limit: {
        presence: true, numericality: { greaterThanOrEqualTo: 1 }
      }
    };
    let constraints = {};
    if (this.props.subscriptionPlan.recurring) {
      let recurringConstraints = {
        ...constraintsPlan,
        price_cents: {
          presence: true, numericality: { strict: true, lessThanOrEqualTo: 1000000000, greaterThanOrEqualTo: 100, message: 'Value not within acceptable range' }
        }
      };

      if (this.props.subscriptionPlan.trial_period_enabled) {
        recurringConstraints = Object.assign({}, recurringConstraints, trialPeriodConstraints);
      }

      constraints = Object.assign(
        {},
        recurringConstraints,
        recurringDurationConstraint(this.props.subscriptionPlan.duration_unit)
      );
    } else {
      constraints = Object.assign({}, constraintsPlan, oneTimeDurationConstraint(this.props.subscriptionPlan.duration_unit));
    }

    if (this.state.subscriptionGroupType === 'group_access') {
      return Object.assign({}, groupAccessUserLimitConstraint, constraints);
    }
    return constraints;
  }

  updateField (field, value) {
    if (field === 'display_assets') {
      this.saveAssets(Object.assign({}, this.props.subscriptionPlan, { [field]: value }));
    } else if (field === 'price_cents') {
      this.setState({ priceCents: value });
      this.props.setSubscriptionPlan(Object.assign({}, this.props.subscriptionPlan, { [field]: currencyUtils.convertToLowestDenomination(value) }));
    } else {
      this.props.setSubscriptionPlan(Object.assign({}, this.props.subscriptionPlan, { [field]: value }));
    }
  }

  updateOccurrenceField (field, value) {
    this.props.setSubscriptionPlan(Object.assign({}, this.props.subscriptionPlan, occurrence.occurrenceToDurationMapping[value]));
  }

  saveAssets (subscriptionPlan) {
    createOrUpdateSubscriptionPlan(this.props.subscriptionGroupId, subscriptionPlan).then((plan) => {
      this.props.setSubscriptionPlan(plan);
      this.props.setErrors(null);
    }, errors => this.props.setErrors(errors.error));
  }

  createRazorpayPlan (e, subscriptionPlanId) {
    e.preventDefault();
    const createPlan = window.confirm('Do you want to link/update this plan in razorpay?');
    if (createPlan === false) return;
    postCreateRemotePlan('razorpay', subscriptionPlanId)
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Payment Gateways updated' } });
        const plan = dotProp.set(this.props.subscriptionPlan, ['metadata', 'razorpay', 'plan_id'], response.remote_subscription_plan.razorpay.id);
        this.props.setSubscriptionPlan(plan);
      },
      (errors) => this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') } }));
  }

  createPaypalPlan (e, subscriptionPlanId) {
    e.preventDefault();
    const message = _.get(this.props.subscriptionPlan, ['metadata', 'paypal', 'plan_id']) ? 'update' : 'create';
    const createPlan = window.confirm(`Do you want to ${message} this plan in Paypal?`);
    if (createPlan === false) return;

    connectRecurringPlan(subscriptionPlanId, 'paypal')
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: `Paypal plan ${message}d successfully` } });
        const plan = dotProp.set(this.props.subscriptionPlan, ['metadata', 'paypal', 'plan_id'], response.plan_id);
        this.props.setSubscriptionPlan(plan);
      }, (errors) => {
        return this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') || 'Error while connecting to paypal' } });
      });
  }

  createVoucherifyPlan (e, subscriptionPlanId) {
    e.preventDefault();
    const createPlan = window.confirm('Do you want to create this plan in Voucherify?');
    if (createPlan === false) return;
    postCreateVoucherifyProduct(subscriptionPlanId)
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Voucherify Product Created Successfully' } });
        const plan = dotProp.set(this.props.subscriptionPlan, ['metadata', 'voucherify', 'product_id'], response.voucherify_product_id);
        this.props.setSubscriptionPlan(plan);
      },
      (errors) => this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') } }));
  }

  createStripeProduct (e, subscriptionPlanId) {
    e.preventDefault();
    const createPlan = window.confirm('Do you want to create this plan in Stripe?');
    if (createPlan === false) return;

    connectRecurringPlan(subscriptionPlanId, 'stripe')
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Stripe Product Created Successfully' } });
        const plan = dotProp.set(this.props.subscriptionPlan, ['metadata', 'stripe', 'plan_id'], response.plan_id);
        this.props.setSubscriptionPlan(plan);
      }, (errors) => {
        return this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') } });
      });
  }

  updateStripeProduct (e, subscriptionPlanId) {
    e.preventDefault();
    const updatePlan = window.confirm('Do you want to update this plan in Stripe?');
    if (updatePlan === false) return;

    updateRecurringPlan(subscriptionPlanId, 'stripe')
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Stripe Product Updated Successfully' } });
        const plan = dotProp.set(this.props.subscriptionPlan, ['metadata', 'stripe', 'plan_id'], response.plan_id);
        this.props.setSubscriptionPlan(plan);
      }, (errors) => {
        return this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') } });
      });
  }

  updateVoucherifyPlan (e, subscriptionPlanId) {
    e.preventDefault();
    const createPlan = window.confirm('Do you want to update this plan in Voucherify?');
    if (createPlan === false) return;
    updateVoucherifyProduct(subscriptionPlanId)
      .then(response => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Voucherify Product Updated Successfully' } });
      },
      (errors) => this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: _.get(errors, ['error', 'message']) || _.get(errors, 'errors') } }));
  }

  getAllSubscriptionPlans () {
    const allSubscriptionPlans = _.flatMap(this.props.subscriptionGroups, (group) => (group.subscription_plans));
    const exceptCurrentPlan = _.filter(allSubscriptionPlans, (plan) => plan.id !== parseInt(this.props.subscriptionPlanId));
    return _.map(exceptCurrentPlan, (plan) => ({ name: plan.title, id: plan.id }));
  }

  getDurationOptions () {
    const planOccurrence = occurrence.getValue(this.props.subscriptionPlan);
    return (planOccurrence === 'one time') ? DURATION_UNITS_ONE_TIME : DURATION_UNITS_RECURRING;
  }

  isPaymentProviderSupported (paymentProvider) {
    return _.get(this.props.subscriptionPlan, ['supported_payment_providers'], []).includes(paymentProvider);
  }

  render () {
    const layout =
      <Layout>
        <TitleBar
          title={this.props.subscriptionPlanId === 'new' ? 'Add Subscription Plan' : 'Edit Subscription Plan'}
          breadcrumbTitle={`${this.state.subscriptionGroupName} Subscription Group`}
          breadcrumbPath={`/subscription_groups/${this.props.subscriptionPlan.subscription_group_id}`}
        />

        <Card title='Subscription Plan Details'>

          <TextFieldWithLabel label='Name' placeholder='Name' value={this.props.subscriptionPlan.title || ''} onChange={(e) => this.updateField('title', e.target.value)} errors={_.get(this.props.errors, ['title', '0'])} dataTest='subscription-plan-name' />
          <TextAreaWithLabel rows='3' label='Description' placeholder='Description' value={this.props.subscriptionPlan.description || ''} onChange={(e) => this.updateField('description', e.target.value)} errors={_.get(this.props.errors, ['description', '0'])} dataTest='subscription-plan-description' />

          <div className='form-row'>
            <SelectFieldWithLabelDatatest
              label='Occurrence'
              value={occurrence.getValue(this.props.subscriptionPlan)}
              options={occurrence.getAllOptions(this.state.subscriptionGroupType)}
              onChange={(m) => this.updateOccurrenceField('occurrence', m.value)}
              clearable={false}
              dataTest='subscription-plan-occurrence'
            />
          </div>

          {(occurrence.getValue(this.props.subscriptionPlan) === 'one time' || occurrence.getValue(this.props.subscriptionPlan) === 'custom') &&
            <div className='duration-container'>
              <div className='form-row'>
                <TextFieldWithLabel
                  errors={_.get(this.props.errors, ['duration_length', '0'])}
                  label='Duration'
                  value={this.props.subscriptionPlan.duration_unit === LIFETIMEVALUE ? this.props.subscriptionPlan.duration_length = 1 : (this.props.subscriptionPlan.duration_length || '')}
                  onChange={(e) => this.updateField('duration_length', e.target.value)}
                  disabled={this.props.subscriptionPlan.duration_unit === LIFETIMEVALUE}
                  dataTest='subscription-plan-duration'
                />
                <SelectFieldWithLabelDatatest
                  label='Time Unit'
                  value={this.props.subscriptionPlan.duration_unit || ''}
                  options={this.getDurationOptions()}
                  onChange={(m) => this.updateField('duration_unit', m.value)}
                  clearable={false}
                  errors={_.get(this.props.errors, ['duration_unit', [0]])}
                  dataTest='subscription-plan-time-unit'
                />
              </div>
            </div>}

          {this.props.subscriptionPlan.recurring && <div className='form-row'>
            <SliderCheckbox
              dataTest='enable_trial_period'
              label='Enable trial period'
              id='enable_trial_period'
              name='enable_trial_period'
              enabled={_.get(this.props.subscriptionPlan, 'trial_period_enabled', false)}
              onChange={(event) => this.updateField('trial_period_enabled', event.target.checked)}
            />
          </div>}

          {this.props.subscriptionPlan.trial_period_enabled &&
            <div className='duration-container'>
              <div className='form-row'>
                <TextFieldWithLabel
                  errors={_.get(this.props.errors, ['max_trial_period_length', '0'])}
                  label='Trial Period Duration'
                  value={this.props.subscriptionPlan.max_trial_period_length || ''}
                  onChange={(e) => this.updateField('max_trial_period_length', e.target.value)}
                  dataTest='trial_period_length'
                />

                <SelectFieldWithLabelDatatest
                  label='Trial period Time Unit'
                  value={this.props.subscriptionPlan.max_trial_period_unit || ''}
                  options={TRIAL_PERIOD_DURATION_UNITS}
                  onChange={(m) => this.updateField('max_trial_period_unit', m.value)}
                  clearable={false}
                  errors={_.get(this.props.errors, ['max_trial_period_unit', [0]])}
                  dataTest='trial_period_unit'
                />
              </div>
            </div>}
          {this.state.subscriptionGroupType === 'group_access' &&
            <div className='form-row'>
              <NumberFieldWithLabel
                label='user limit'
                value={this.props.subscriptionPlan.user_limit || ''}
                onChange={(e) => this.updateField('user_limit', e.target.value)}
                errors={_.get(this.props.errors, ['user_limit', '0']) || _.get(this.props.errors, ['user_limit', '0'])}
                placeholder='Enter user limit'
                dataTest='subscription-user-limit'
              />
            </div>}
          <div className='form-row'>
            <div className='text-and-select'>
              <NumberFieldWithLabel
                label='price'
                value={this.state.priceCents}
                onChange={(e) => this.updateField('price_cents', e.target.value)}
                errors={_.get(this.props.errors, ['price', '0']) || _.get(this.props.errors, ['price_cents', '0'])}
                placeholder='Enter price'
                dataTest='subscription-plan-price'
              />
              <Select
                className='select-currency'
                value={this.props.subscriptionPlan.price_currency}
                options={this.state.subscriptionGroupType === 'campaign' ? getOption(this.state.subscriptionGroupCurrency) : ALL_CURRENCIES}
                onChange={(m) => m !== null ? this.updateField('price_currency', m.value) : null}
                clearable={false}
                searchable
                arrowRenderer={currencyUtils.arrowRenderer}
                autosize={false}
              />
            </div>
            {!this.props.subscriptionPlan.recurring && this.state.voucherifyEnabled &&
              <TextFieldWithLabel
                label='Voucherify Product ID'
                placeholder='This plan is not linked with Voucherify'
                disabled
                dataTest='voucherify-product-id'
                value={_.get(this.props.subscriptionPlan.metadata, ['voucherify', 'product_id'], '')}
              />}
          </div>
          <div className='link-gateways'>
            <div>
              {this.props.subscriptionPlan.recurring && this.props.subscriptionPlanId !== 'new' && this.isPaymentProviderSupported('razorpay') &&
                <TextFieldWithLabel
                  label='Razorpay Plan ID'
                  placeholder='This recurring plan is not linked with Razorpay'
                  disabled
                  value={_.get(this.props.subscriptionPlan.metadata, ['razorpay', 'plan_id'], '')}
                />}
              <div>

                {this.state.superUser && this.isPaymentProviderSupported('razorpay') && this.props.subscriptionPlanId !== 'new' && this.props.subscriptionPlan.recurring &&
                  <Link onClick={(e) => this.createRazorpayPlan(e, this.props.subscriptionPlanId)} dataTest='razorpay-update'>
                    {_.get(this.props.subscriptionPlan, ['metadata', 'razorpay', 'plan_id']) ? 'Update Razorpay' : 'Connect Razorpay'}
                  </Link>}
              </div>
            </div>

            <div>
              {this.props.subscriptionPlan.recurring && this.props.subscriptionPlanId !== 'new' && this.isPaymentProviderSupported('stripe') &&
                <TextFieldWithLabel
                  label='Stripe Plan ID'
                  dataTest='stripe-plan-id'
                  placeholder='This recurring plan is not linked with Stripe'
                  disabled
                  value={_.get(this.props.subscriptionPlan.metadata, ['stripe', 'plan_id'], '')}
                />}
              <div>
                {this.state.superUser && this.isPaymentProviderSupported('stripe') && this.props.subscriptionPlanId !== 'new' && this.props.subscriptionPlan.recurring && _.get(this.props.subscriptionPlan, ['metadata', 'stripe', 'plan_id']) &&
                  <Link onClick={(e) => this.updateStripeProduct(e, this.props.subscriptionPlanId)} dataTest='stripe-update'>
                  Update Stripe
                  </Link>}
                {this.state.superUser && this.isPaymentProviderSupported('stripe') && this.props.subscriptionPlanId !== 'new' && this.props.subscriptionPlan.recurring && !_.get(this.props.subscriptionPlan, ['metadata', 'stripe', 'plan_id']) &&
                  <Link onClick={(e) => this.createStripeProduct(e, this.props.subscriptionPlanId)} dataTest='stripe-connect'>
                  Connect Stripe
                  </Link>}
              </div>
            </div>
          </div>

          <div>
            {this.props.subscriptionPlan.recurring && this.props.subscriptionPlanId !== 'new' && this.isPaymentProviderSupported('paypal') &&
              <TextFieldWithLabel
                label='Paypal Plan ID'
                placeholder='This recurring plan is not linked with Paypal'
                disabled
                value={_.get(this.props.subscriptionPlan.metadata, ['paypal', 'plan_id'], '')}
              />}
            <div>

              {this.state.superUser && this.isPaymentProviderSupported('paypal') && this.props.subscriptionPlanId !== 'new' && this.props.subscriptionPlan.recurring &&
                <Link onClick={(e) => this.createPaypalPlan(e, this.props.subscriptionPlanId)} dataTest='paypal-update'>
                  {_.get(this.props.subscriptionPlan, ['metadata', 'paypal', 'plan_id']) ? 'Update Paypal' : 'Connect Paypal'}
                </Link>}
            </div>
          </div>

          {this.props.subscriptionPlanId !== 'new' && this.state.voucherifyEnabled && !this.props.subscriptionPlan.recurring && _.get(this.props.subscriptionPlan, ['metadata', 'voucherify', 'product_id']) &&
            <Link onClick={(e) => this.updateVoucherifyPlan(e, this.props.subscriptionPlanId)} dataTest='voucherify-update'>
            Update Voucherify
            </Link>}

          {this.props.subscriptionPlanId !== 'new' && this.state.voucherifyEnabled &&
           !this.props.subscriptionPlan.recurring && !_.get(this.props.subscriptionPlan, ['metadata', 'voucherify', 'product_id']) &&
             <Link onClick={(e) => this.createVoucherifyPlan(e, this.props.subscriptionPlanId)}>
            Connect Voucherify
             </Link>}

        </Card>
        <Card>
          <Assets
            assets={this.props.subscriptionPlan.display_assets || []}
            onChange={(assets) => this.updateField('display_assets', assets)}
            onSave={(e) => this.saveAssets(e)}
            assetCategories={this.state.assetCategories}
            errors={this.props.errors}
            id={this.props.subscriptionPlanId}
            assetsFor='Subscription Plan'
            showPublishedAt = {this.props.subscriptionPlan.duration_unit === 'lifetime'}
            assetFrom={this.getAllSubscriptionPlans()}
          />
        </Card>
        <ButtonGroup columns={this.props.subscriptionPlanId !== 'new' ? 'two' : ''}>
          {this.props.subscriptionPlanId !== 'new' &&
            <Button onClick={(e) => this.openAlert(e)} destructive> Delete </Button>}
          <Button onClick={(e) => this.createUpdateSubscriptionPlan()} primary> Save </Button>
        </ButtonGroup>

        <Alert
          title='Delete Subscription Plan'
          open={this.state.openAlertPopup}
          destructive
          onCancel={() => this.closeAlert()}
          onConfirm={(e) => this.deleteSubscriptionPlan(e)}
        >
            Deleted data cannot be recovered. Do you still want to continue?
        </Alert>

        {this.state.showNotification.isNotificationOpen &&
          <StatusMessage
            statusMessage={this.state.showNotification.statusMessage}
            status={this.state.showNotification.status}
            onCancel={() => this.setState({ showNotification: { isNotificationOpen: false, status: '', statusMessage: '' } })}
          />}
      </Layout>;

    return (layout);
  }
}
function mapStateToProps (state) {
  return {
    subscriptionPlan: state.subscriptionPlan || {},
    errors: state.errors || [],
    subscriptionGroups: state.subscriptionGroups || []
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setSubscriptionPlan: (plan) => dispatch({ type: SET_SUBSCRIPTION_PLAN, subscriptionPlan: plan }),
    setErrors: (errors) => dispatch({ type: SET_ERRORS, errors: errors }),
    setSubscriptionGroups: (plans) => dispatch({ type: UPDATE_SUBSCRIPTION_GROUPS, subscriptionGroups: plans })
  };
}

const constraintsPlan = {
  title: { presence: { allowEmpty: false } },
  description: { presence: { allowEmpty: false } },
  price_cents: { presence: true, numericality: { strict: true, lessThanOrEqualTo: 1000000000, greaterThanOrEqualTo: 0, message: 'Value not within acceptable range' } }
};

const trialPeriodConstraints = {
  max_trial_period_length: { presence: true, numericality: { strict: true, onlyInteger: true, greaterThan: 0, lessThanOrEqualTo: 999999 } },
  max_trial_period_unit: { presence: { message: 'cannot be empty' } }
};

function oneTimeDurationConstraint (durationUnit) {
  return { duration_length: { presence: true, numericality: { strict: true, onlyInteger: true, greaterThan: 0, lessThanOrEqualTo: maximumOneTimeDuration[durationUnit] } } };
}

const maximumOneTimeDuration = {
  days: 36524,
  weeks: 5217,
  months: 1200,
  years: 100,
  lifetime: 1
};

function recurringDurationConstraint (durationUnit) {
  return { duration_length: { presence: true, numericality: { strict: true, onlyInteger: true, greaterThan: 0, lessThanOrEqualTo: maximumRecurringDuration[durationUnit] } } };
}

const maximumRecurringDuration = {
  days: 3650,
  weeks: 52,
  months: 12,
  years: 10
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUpdateSubscriptionPlan);
